import styled, { keyframes } from 'styled-components';
function Main() {
  return (
    <Wrap>
      <ImageWrap></ImageWrap>
      <MainText>
        <TextWrap>
          <TextFadIn01>
            언제나 고객을 위해 <br />
          </TextFadIn01>
          <TextFadIn02>
            최선의 <span>해법</span>을 제시합니다
          </TextFadIn02>
          <h4>
            법률사무소 훈 <img src="/images/name_hoon.png" />
          </h4>
        </TextWrap>
      </MainText>
    </Wrap>
  );
}
export default Main;
const UnderLine = keyframes`
  0% {
    width:0%
  }
  100% {
    width:80%;
  }
`;
const FadeIn = keyframes`
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: none;
  }
`;
const TextFadIn02 = styled.p`
  position: relative;
  overflow: hidden;
  animation: ${FadeIn} 1.5s ease-in-out;
  animation-delay: 0.3s;
`;
const TextFadIn01 = styled.p`
  position: relative;
  overflow: hidden;
  animation: ${FadeIn} 1.5s ease-in-out;
`;
const TextWrap = styled.div`
  color: #fff;
  font-weight: bold;
  font-size: 50px;
  h4 {
    margin-top: 45px;
    font-size: 30px;
    font-weight: 400;
    color: #f1bf78;
    position: relative;
    animation: ${FadeIn} 1.5s ease-in-out;
    animation-delay: 0.5s;
    img {
      position: absolute;
      top: -15px;
      margin-left: 20px;
      width: 230px;
    }
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 80%;
      height: 2px;
      background: linear-gradient(to right, #fff, #f1bf78, #a07b53);
      animation: ${UnderLine} 1.5s ease-in-out;
      animation-delay: 0.4s;
      @media only screen and (max-width: 1200px) {
        display: none;
      }
    }
  }
  @media only screen and (max-width: 1200px) {
    h4 {
      margin-top: 25px;
      width: 80%;
    }
  }
  @media only screen and (max-width: 740px) {
    margin-bottom: 0px;
    font-size: 25px;
    h4 {
      margin-top: 15px;
      font-size: 20px;
      width: 100%;
      text-align: center;
      img {
        position: relative;
        display: block;
        width: 120px;
        margin: 0 auto;
        margin-top: 20px;
      }
    }
  }
`;
const MainText = styled.div`
  display: flex;
  align-items: center;
  width: 50%;
  min-width: 600px;
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  span {
    color: #f1bf78;
  }
  @media only screen and (max-width: 1200px) {
    top: initial;
    text-align: center;
    width: 100%;
    display: block;
    bottom: 20px;
    height: 200px;
  }
  @media only screen and (max-width: 740px) {
    min-width: initial;
    height: 150px;
  }
`;
const ImageWrap = styled.div`
  position: absolute;
  width: 80%;
  height: calc(100vh - 30px);
  background: url('/images/hoon_img_01.png') no-repeat;
  background-size: auto 100%;
  background-position: left bottom;
  bottom: 0;
  left: 0;
  margin-left: 10%;
  @media only screen and (max-width: 1100px) {
    width: 100%;
    margin-left: 0px;
  }
  @media only screen and (max-width: 740px) {
    background-size: 100%;
    top: 0;
    height: 600px;
    max-width: 480px;
    min-width: 300px;
  }
`;

const Wrap = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  /* background: linear-gradient(to bottom right, #0c0c19, #4a4748); */
  background: linear-gradient(rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75)),
    url('/images/main_back.jpg') no-repeat;
  background-position: center center;
  background-attachment: fixed;
  background-size: cover;
  @media only screen and (max-width: 740px) {
    height: 600px;
    background-position: 0 0;
    background-size: auto 600px;
    background: url('/images/main_back_mobile.png');
  }
`;
